import { FC } from "react";
import { Flex, Heading } from "@chakra-ui/react";
import { sharedProps } from "~/constants";

const text = {
  heading: "Frequently Asked Questions",
};

export const Hero: FC = () => {
  return (
    <Flex
      align="center"
      bg="bg-main-accent"
      direction="column"
      h="100%"
      justify="center"
      minH="14rem"
      maxW="inherit"
      textAlign="center"
      w="100%"
    >
      <Flex direction="column" {...sharedProps.max.content}>
        <Heading
          as="h1"
          color="on-accent"
          fontWeight="light"
          py={{ base: 6, md: 8 }}
          size="2xl"
        >
          {text.heading}
        </Heading>
      </Flex>
    </Flex>
  );
};
